import { CircularProgress, Skeleton } from '@mui/material';

export function DashboardMealsSkeleton() {
	return (
		<div className='w-full flex flex-col gap-3' aria-hidden='true'>
			<div className='flex w-full flex-col gap-1'>
				<Skeleton variant='text' width='48%' height={22} />
				<Skeleton variant='text' width='72%' height={18} />
			</div>
			<ChildCardSkeleton />
			<ChildCardSkeleton />
		</div>
	);
}

function ChildCardSkeleton() {
	return (
		<article className='kid w-full' aria-hidden='true'>
			<div className='kidhead'>
				<div className='flex min-w-0 flex-1 items-center gap-3'>
					<Skeleton variant='circular' width={40} height={40} sx={{ flexShrink: 0 }} />
					<div className='flex min-w-0 flex-1 flex-col gap-1'>
						<Skeleton variant='text' width='72%' height={24} />
						<Skeleton variant='text' width='48%' height={18} />
					</div>
				</div>
				<Skeleton variant='rounded' width={88} height={22} sx={{ flexShrink: 0 }} />
			</div>
			<div className='status-grid' style={{ marginTop: 12 }}>
				<Skeleton variant='rounded' height={56} sx={{ width: '100%' }} />
				<Skeleton variant='rounded' height={56} sx={{ width: '100%' }} />
			</div>
			<div className='kidbody' style={{ marginTop: 12 }}>
				<Skeleton variant='rounded' height={72} sx={{ width: '100%' }} />
			</div>
		</article>
	);
}

/** Shown while dashboard meal status is loading (initial or date change). */
export default function DashboardMealsLoading() {
	return (
		<div className='w-full flex flex-col gap-4 py-2' role='status' aria-live='polite' aria-busy='true'>
			<div className='flex w-full justify-center'>
				<CircularProgress size={32} sx={{ color: 'var(--bzGreen)' }} aria-hidden='true' />
			</div>
			<p className='sr-only'>Loading meals for this date…</p>
			<DashboardMealsSkeleton />
		</div>
	);
}
